import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { ScanConfiguration } from 'src/app/models/ScanConfigurationModel';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { PlatformApiService, ResultFilter, Results } from 'src/app/services/platform-api.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'cw-ci-scan-configuration-list',
  templateUrl: './scan-configuration-list.component.html',
  styleUrls: []
})
export class ScanConfigurationListComponent implements OnInit {
  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(DataTableComponent, { static: true }) scanConfigurationDataTable: DataTableComponent;
  scanConfigurationList: Results;

  constructor(private _platformApi: PlatformApiService, public dialog: MatDialog) { }

  ngOnInit() {

  }

  isSelectable(item: ScanConfiguration) {
    return true;
  }

  addScanConfiguration(event?) {
    this.stateChange.emit({ state: 'CREATE' });
  }

  editScanConfiguration(item: ScanConfiguration) {
    this.stateChange.emit({ state: 'EDIT', item });
  }

  loadScanConfigurations(filter = new ResultFilter()) {
    this.scanConfigurationDataTable.showProcessing();
    const listObservable = this._platformApi.getScanConfigurations(filter);
    listObservable.subscribe(results => {
      this.scanConfigurationList = results;
    })
  }
}
